module.exports = __webpack_public_path__ + "img/focaccia_done.39a777a9.jpg";